import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from '../../../../permission/AuthorizedRoute';
import { PAGE_NAMES, RESOURCES, SETTINGS_V2_ACTION } from '../../../../settingsV2Constant';

import CreatePermissions from './submodules/create';
import EditPermissions from './submodules/edit';
import ListPermissions from './submodules/list';

const PermissionsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.permissionsManagement}
				configResourceName={RESOURCES.permission}
				configActionName={SETTINGS_V2_ACTION.listPermission}
				path={`${path}/list`}
				component={ListPermissions}
				exact
			/>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.permissionsManagement}
				configResourceName={RESOURCES.permission}
				configActionName={SETTINGS_V2_ACTION.createPermission}
				path={`${path}/create`}
				component={CreatePermissions}
				exact
			/>
			<AuthorizedRoute
				configPageName={PAGE_NAMES.permissionsManagement}
				configResourceName={RESOURCES.permission}
				configActionName={SETTINGS_V2_ACTION.editPermission}
				exact
				path={`${path}/edit`}
				component={EditPermissions}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default PermissionsDashboard;
